import { pageOf, shopListingSchema } from "@shared/contracts";
import { request } from "../../platform/api/request";

export function fetchListings(cursor: string | null, signal: AbortSignal) {
  return request(
    `/shop${cursor ? `?cursor=${encodeURIComponent(cursor)}` : ""}`,
    pageOf(shopListingSchema),
    { signal },
  );
}
export function fetchListing(slug: string, signal: AbortSignal) {
  return request(`/shop/${encodeURIComponent(slug)}`, shopListingSchema, { signal });
}
